import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "superTalentMetrics.title",
    defaultMessage: "SuperTalent",
  },
  description: {
    id: "superTalentMetrics.description",
    defaultMessage:
      "Become one of our <bold>most reliable providers</bold> and enjoy the advantages:",
  },
  superTalentDescription: {
    id: "superTalentMetrics.superTalentDescription",
    defaultMessage:
      "You are one of our <bold>most reliable providers</bold> and can now enjoy the full advantages:",
  },
  perkEarlyJobs: {
    id: "superTalentMetrics.perkEarlyJobs",
    defaultMessage: "Receive jobs <bold>3 hours</bold> in advance",
  },
  perkBadge: {
    id: "superTalentMetrics.perkBadge",
    defaultMessage:
      "Display our mark of reliability: the <bold>SuperTalent badge</bold>",
  },
  perkUnlimitedJobs: {
    id: "superTalentMetrics.perkUnlimitedJobs",
    defaultMessage: "<bold>Unlimited</bold> ongoing jobs",
  },
  currentAdvantagesTitle: {
    id: "superTalentMetrics.currentAdvantagesTitle",
    defaultMessage: "Your advantages",
  },
  almostThere: {
    id: "superTalentMetrics.almostThere",
    defaultMessage: "You're almost there!",
  },
  bonusEarlyJobs: {
    id: "superTalentMetrics.bonusEarlyJobs",
    defaultMessage: "<bold>Bonus</bold>: You see jobs <bold>2h sooner</bold>",
  },
  goalsTitle: {
    id: "superTalent.superTalentGoals",
    defaultMessage: "Vos objectifs SuperTalent",
  },
  visibleOnlyToYou: {
    id: "superTalent.visibleByYou",
    defaultMessage: "<eyeIcon></eyeIcon> Uniquement visible par vous",
  },
  goalsDescription: {
    id: "superTalent.goalsInfos",
    defaultMessage:
      "Chaque mois, nous évaluons si vous avez atteint les objectifs. Atteignez-les et devenez SuperTalent !",
  },
  goalsDescriptionInBetween: {
    id: "superTalent.goalsInfosInBetween",
    defaultMessage:
      "Next month, SuperTalent rules will change. Discover the new avantages below and reach them before the next evaluation!",
  },
  yourScore: {
    id: "superTalentMetrics.yourScore",
    defaultMessage: "Your score",
  },
  bonusSeeJobsSooner: {
    id: "superTalentMetrics.bonusSeeJobsSooner",
    defaultMessage: "<bold>Bonus</bold>: See jobs <bold>2h sooner</bold>",
  },
  nextEvaluation: {
    id: "superTalent.nextEvaluation",
    defaultMessage:
      "<magnifyingGlass></magnifyingGlass>Prochaine évaluation :<nextComputedDate></nextComputedDate>",
  },
  calculatedOver: {
    id: "superTalent.dateComputed",
    defaultMessage: "<calendar></calendar>Calculés sur 12 mois",
  },
  charterTitle: {
    id: "superTalentMetrics.charterTitle",
    defaultMessage: "The Ring Twice Charter",
  },
  charterDescription: {
    id: "superTalentMetrics.charterDescription",
    defaultMessage: "The basics for Quality and Trust",
  },
  charterStatus: {
    id: "superTalentMetrics.charterStatus",
    defaultMessage: "Read and respected",
  },
  verifiedTitle: {
    id: "superTalentMetrics.verifiedTitle",
    defaultMessage: "Proudly verified",
  },
  verifiedDescription: {
    id: "superTalentMetrics.verifiedDescription",
    defaultMessage: "Submit your ID for verification",
  },
  verifiedStatus: {
    id: "superTalentMetrics.verifiedStatus",
    defaultMessage: "Not verified yet",
  },
  verifiedStatusRejected: {
    id: "superTalentMetrics.verifiedStatusRejected",
    defaultMessage: "ID rejected",
  },
  profilePicTitle: {
    id: "superTalentMetrics.profilePicTitle",
    defaultMessage: "Put a face to the name",
  },
  profilePicDescription: {
    id: "superTalentMetrics.profilePicDescription",
    defaultMessage: "Submit your picture for review",
  },
  profilePicStatus: {
    id: "superTalentMetrics.profilePicStatus",
    defaultMessage: "Not validated yet",
  },
  topPickTitle: {
    id: "superTalentMetrics.topPickTitle",
    defaultMessage: "Top pick",
  },
  promiseKeeperTitle: {
    id: "superTalentMetrics.promiseKeeperTitle",
    defaultMessage: "Promise keeper",
  },
  loyalClienteleTitle: {
    id: "superTalentMetrics.loyalClienteleTitle",
    defaultMessage: "Loyal clientele",
  },
  starTalentTitle: {
    id: "superTalentMetrics.starTalentTitle",
    defaultMessage: "Star talent",
  },
  minThreshold: {
    id: "superTalentMetrics.minThreshold",
    defaultMessage: "Min. {value}%",
  },
  minRating: {
    id: "superTalentMetrics.minRating",
    defaultMessage: "Min. {value} client evaluation",
  },
  assignmentFooter: {
    id: "superTalentMetrics.assignmentFooter",
    defaultMessage: "{count} assignments · {total} offers sent",
  },
  cancellationFooter: {
    id: "superTalentMetrics.cancellationFooter",
    defaultMessage: "{count} cancelled · {total} closed",
  },
  recurringFooter: {
    id: "superTalentMetrics.recurringFooter",
    defaultMessage: "{count} recurring · {total} clients",
  },
  reviews: {
    id: "superTalentMetrics.reviews",
    defaultMessage: "({count} reviews)",
  },
  clientsClosedTitle: {
    id: "superTalentMetrics.clientsClosedTitle",
    defaultMessage: "Clients closed",
  },
  clientsClosedDescription: {
    id: "superTalentMetrics.clientsClosedDescription",
    defaultMessage: "Min. {value} unique",
  },
  charterStatusNotReached: {
    id: "superTalentMetrics.charterStatusNotReached",
    defaultMessage: "Not respected",
  },
  verifiedStatusReached: {
    id: "superTalentMetrics.verifiedStatusReached",
    defaultMessage: "Verified",
  },
  profilePicStatusReached: {
    id: "superTalentMetrics.profilePicStatusReached",
    defaultMessage: "Validated",
  },
  profilePicStatusPending: {
    id: "superTalentMetrics.profilePicStatusPending",
    defaultMessage: "Under review",
  },
  profilePicStatusRefused: {
    id: "superTalentMetrics.profilePicStatusRefused",
    defaultMessage: "Picture rejected",
  },
  profilePicTryAgain: {
    id: "superTalentMetrics.profilePicTryAgain",
    defaultMessage: "Try again",
  },
  noAdvantagesYet: {
    id: "superTalentMetrics.noAdvantagesYet",
    defaultMessage: "No advantages yet!",
  },
  noAdvantagesDescription: {
    id: "superTalentMetrics.noAdvantagesDescription",
    defaultMessage: "Continue working with Ring Twice to reach the goals",
  },
  newbieBoostActiveDescription: {
    id: "superTalentMetrics.newbieBoostActiveDescription",
    defaultMessage: "You got the <bold>Newbie boost</bold>, so this month you get the following advantage:",
  },
  newbieBoostBanner: {
    id: "superTalentMetrics.newbieBoostBanner",
    defaultMessage: "<bold>Newbie boost</bold>: enjoy exceptional advantages for a month",
  },
  newbieBoostFormUrl: {
    id: "superTalentMetrics.newbieBoostFormUrl",
    defaultMessage: "https://form.typeform.com/to/lAbO72mv",
  },
  onTheRightTrack: {
    id: "superTalentMetrics.onTheRightTrack",
    defaultMessage: "You're on the right track!",
  },
  cardBonus1hSooner: {
    id: "superTalentMetrics.cardBonus1hSooner",
    defaultMessage: "<bonus>Bonus</bonus>: You see jobs <bold>1h sooner</bold>",
  },
  cardBonus2hSooner: {
    id: "superTalentMetrics.cardBonus2hSooner",
    defaultMessage: "<bonus>Bonus</bonus>: You see jobs <bold>2h sooner</bold>",
  },
  proDescription: {
    id: "superTalentMetrics.proDescription",
    defaultMessage: "As a PRO, you always have access to the following advantage:",
  },
  proProgress: {
    id: "superTalentMetrics.proProgress",
    defaultMessage: "You still need to reach 8/8 to become SuperTalent",
  },
  profilePicModalEmptyLine1: {
    id: "superTalentMetrics.profilePicModalEmptyLine1",
    defaultMessage: "Upload a profile picture before submitting it for approval",
  },
  profilePicModalEmptyLine2: {
    id: "superTalentMetrics.profilePicModalEmptyLine2",
    defaultMessage:
      "To do so, go to <bold>Compte > Gestion de mon compte > Mon profil</bold>",
  },
  profilePicModalEmptyLine3: {
    id: "superTalentMetrics.profilePicModalEmptyLine3",
    defaultMessage: "Once uploaded, return here and submit for approval",
  },
  profilePicModalGoToProfile: {
    id: "superTalentMetrics.profilePicModalGoToProfile",
    defaultMessage: "Go to \"My profile\"",
  },
  profilePicModalNotValidatedTitle: {
    id: "superTalentMetrics.profilePicModalNotValidatedTitle",
    defaultMessage: "Submit your profile picture for approval",
  },
  profilePicModalReminder: {
    id: "superTalentMetrics.profilePicModalReminder",
    defaultMessage:
      "Reminder: your profile picture must be a photo of yourself, facing the camera. No landscape shots or photos taken from behind.",
  },
  profilePicModalModifyPhoto: {
    id: "superTalentMetrics.profilePicModalModifyPhoto",
    defaultMessage: "Go to profile to modify",
  },
  profilePicModalSubmit: {
    id: "superTalentMetrics.profilePicModalSubmit",
    defaultMessage: "Submit for approval",
  },
  profilePicModalPendingTitle: {
    id: "superTalentMetrics.profilePicModalPendingTitle",
    defaultMessage: "Your profile picture is pending approval",
  },
  profilePicModalPendingText: {
    id: "superTalentMetrics.profilePicModalPendingText",
    defaultMessage:
      "This usually takes a few days. If it has not been approved after a week, you can <link>contact support</link>.",
  },
  profilePicModalDoneTitle: {
    id: "superTalentMetrics.profilePicModalDoneTitle",
    defaultMessage: "Profile picture approved",
  },
  profilePicModalDoneDesc: {
    id: "superTalentMetrics.profilePicModalDoneDesc",
    defaultMessage:
      "We've approved your photo, as it signals quality to clients. If needed, you can always edit it from your profile. However, please note that it will need to be approved again.",
  },
  profilePicModalClose: {
    id: "superTalentMetrics.profilePicModalClose",
    defaultMessage: "Close",
  },
});
